document.addEventListener("DOMContentLoaded", function () {
  function waitForKlaviyo() {
    if (window.klaviyo && window.klaviyo.enable) {
      window.klaviyo.enable("backinstock", {
        trigger: {
          product_page_class: "klaviyo-bis-trigger",
        }
      });

      console.log("Klaviyo BIS initialized ✅");
    } else {
      setTimeout(waitForKlaviyo, 200);
    }
  }

  waitForKlaviyo();
});